/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { StarFilledIcon } from '@coursera/cds-icons';

import { MIN_RATING_COUNT } from 'bundles/product-card/constants';

import _t from 'i18n!nls/product-card';

type Props = { avgProductRating?: number; numProductRatings?: number };

const styles = {
  ratingContainer: css`
    display: flex;
    align-items: center;
    gap: calc(var(--cds-spacing-50) / 2);
  `,
  ratingText: css`
    display: inline-block;
    line-height: 1;
  `,
};

export const getRoundedRating = (rating: number) => Math.round(rating * 10) / 10;

const ProductCardReviews = ({ avgProductRating, numProductRatings }: Props) => {
  if (!avgProductRating || !numProductRatings || numProductRatings <= MIN_RATING_COUNT) {
    return null;
  }

  const rating = getRoundedRating(avgProductRating);

  return (
    <div
      role="img"
      aria-roledescription="rating"
      aria-label={_t('Rated #{rating} out of 5 stars', { rating })}
      css={styles.ratingContainer}
    >
      <StarFilledIcon color="default" size="small" aria-hidden="true" />
      <Typography2
        variant="bodyTertiary"
        component="span"
        color="supportText"
        css={styles.ratingText}
        aria-hidden="true"
      >
        {rating}
      </Typography2>
    </div>
  );
};

export default ProductCardReviews;
